// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IRecordDto } from './IRecordDto';
import {
    IRecordDtoFromJSON,
    IRecordDtoFromJSONTyped,
    IRecordDtoToJSON,
    IRecordDtoToJSONTyped,
} from './IRecordDto';

/**
 * 
 * @export
 * @interface IContributionResponseDto
 */
export interface IContributionResponseDto {
    /**
     * 
     * @type {string}
     * @memberof IContributionResponseDto
     */
    contribution_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionResponseDto
     */
    status?: IContributionResponseDtoStatusEnum;
    /**
     * 
     * @type {Array<IRecordDto>}
     * @memberof IContributionResponseDto
     */
    records?: Array<IRecordDto>;
    /**
     * 
     * @type {number}
     * @memberof IContributionResponseDto
     */
    ee_contribution_hold_days?: number;
    /**
     * 
     * @type {string}
     * @memberof IContributionResponseDto
     */
    contribution_source?: IContributionResponseDtoContributionSourceEnum;
    /**
     * 
     * @type {Date}
     * @memberof IContributionResponseDto
     */
    submit_date?: Date;
    /**
     * 
     * @type {number}
     * @memberof IContributionResponseDto
     */
    request_version?: number;
}

/**
* @export
* @enum {string}
*/
export enum IContributionResponseDtoStatusEnum {
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    COMPLETED_WITH_ERRORS = 'COMPLETED_WITH_ERRORS',
    ERROR = 'ERROR',
    VALIDATION_FAILED = 'VALIDATION_FAILED',
    APPROVAL_NEEDED = 'APPROVAL_NEEDED',
    REJECTED = 'REJECTED',
    SUBMITTED = 'SUBMITTED'
}
/**
* @export
* @enum {string}
*/
export enum IContributionResponseDtoContributionSourceEnum {
    FPS = 'FPS',
    API = 'API',
    UI = 'UI',
    RECURRING = 'RECURRING',
    SCHEDULED = 'SCHEDULED'
}


/**
 * Check if a given object implements the IContributionResponseDto interface.
 */
export function instanceOfIContributionResponseDto(value: object): value is IContributionResponseDto {
    return true;
}

export function IContributionResponseDtoFromJSON(json: any): IContributionResponseDto {
    return IContributionResponseDtoFromJSONTyped(json, false);
}

export function IContributionResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContributionResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contribution_id': json['contribution_id'] == null ? undefined : json['contribution_id'],
        'status': json['status'] == null ? undefined : json['status'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(IRecordDtoFromJSON)),
        'ee_contribution_hold_days': json['ee_contribution_hold_days'] == null ? undefined : json['ee_contribution_hold_days'],
        'contribution_source': json['contribution_source'] == null ? undefined : json['contribution_source'],
        'submit_date': json['submit_date'] == null ? undefined : (new Date(json['submit_date'])),
        'request_version': json['request_version'] == null ? undefined : json['request_version'],
    };
}

export function IContributionResponseDtoToJSON(json: any): IContributionResponseDto {
    return IContributionResponseDtoToJSONTyped(json, false);
}

export function IContributionResponseDtoToJSONTyped(value?: IContributionResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contribution_id': value['contribution_id'],
        'status': value['status'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(IRecordDtoToJSON)),
        'ee_contribution_hold_days': value['ee_contribution_hold_days'],
        'contribution_source': value['contribution_source'],
        'submit_date': value['submit_date'] == null ? undefined : ((value['submit_date']).toISOString().substring(0,10)),
        'request_version': value['request_version'],
    };
}

